<template>
  <tr :class="school.status === 'archived' ? 'negative' : ''">
    <td>
      <sui-button v-for="action in actionList" v-bind:content="action" v-on:click="buttonAction(action)"
        v-bind:key="action" />
    </td>
    <td>{{ school.rollNumber }}</td>
    <td>{{ school.name }}</td>
    <td>{{ school.totalStudentCount }}</td>
  </tr>
</template>

<script>
export default {
  name: 'SchoolTableRow',
  props: ['school', 'actions'],
  computed: {
    actionList() {
      return this.actions || [];
    },
  },
  methods: {
    buttonAction(value) {
      this.$emit('action', { action: value, school: this.school });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/schools/SchoolTableRow.vue